import React from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Mike Rodriguez',
      role: 'Fleet Manager',
      company: 'TransCore Logistics',
      content: 'Outstanding rust prevention service! Our truck fleet looks brand new and maintenance costs have dropped 40%.',
      rating: 5,
    },
    {
      name: 'Sarah Chen',
      role: 'Marine Operations Director',
      company: 'Pacific Harbor Marina',
      content: 'Professional team with incredible attention to detail. Our dock equipment is now fully protected from salt water corrosion.',
      rating: 5,
    },
    {
      name: 'David Thompson',
      role: 'Plant Manager',
      company: 'Industrial Solutions Inc.',
      content: 'The preventative maintenance plan has saved us thousands. Highly recommend for any industrial operation.',
      rating: 5,
    },
    {
      name: 'Lisa Martinez',
      role: 'Operations Manager',
      company: 'Coastal Manufacturing',
      content: 'Emergency rust response saved our production line. Quick, professional, and effective solution.',
      rating: 5,
    },
    {
      name: 'Robert Kim',
      role: 'Maintenance Supervisor',
      company: 'Metro Construction',
      content: 'Their coating system has protected our equipment for over 3 years now. Exceptional quality and service.',
      rating: 5,
    },
    {
      name: 'Amanda Foster',
      role: 'Facility Director',
      company: 'Harbor Industries',
      content: 'Mobile service is incredibly convenient. They restored our machinery on-site with minimal downtime.',
      rating: 5,
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center w-full bg-gray-900 dark:bg-black">
        
        <div className="relative z-10 px-6 lg:px-8 py-20 text-center text-white w-full max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Customer <span className="text-orange-400">Testimonials</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            Hear what our satisfied customers say about our rust protection services
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20 px-6 bg-white dark:bg-gray-900">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-lg transition-all duration-300 hover:scale-105"
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-orange-400 fill-current" />
                  ))}
                </div>
                <p className="mb-4 italic text-gray-600 dark:text-gray-300">
                  "{testimonial.content}"
                </p>
                <div>
                  <div className="font-semibold text-gray-900 dark:text-white">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-500 dark:text-gray-400">
                    {testimonial.role}
                  </div>
                  <div className="text-sm text-orange-600 dark:text-orange-400">
                    {testimonial.company}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
